<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>Api Request 설정하기</h2>
        <!-- <p>Authentication Fields (required)</p> -->
        <!-- <p>Build a form with fields for each item your API requires for authentication, including a field for your API key and additional field for any other data needed. Zapier does not include any fields by default.</p> -->
      </div>
      <div class="body">
        <!-- <div class="mb-3">
                                <label class="c_radio">
                                    <input type="radio" name="radio1" id="radio1" value="hook" v-model="checkingMenu" @change="changeComponent" checked="">
                                    <span class="checkmark"></span>
                                    <span class="ml-2">REST Hook</span>
                                </label>
                            </div> -->
        <div class="mb-3">
          <label class="c_radio">
            <input
              type="radio"
              name="radio1"
              id="radio2"
              value="polling"
              v-model="checkingMenu"
              @change="changeComponent"
              checked=""
            />
            <span class="checkmark"></span>
            <span class="ml-2">Polling</span>
          </label>
        </div>
      </div>
      <my-component v-bind:is="componentChange" />

      <div></div>
    </div>

    <div style="text-align: right; margin-bottom: 10px">
      <button type="button" class="btn btn-primary" :disabled="saveBtn" @click="insertTriggerData"><i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw circleIcon" style="display:none;"></i>
        저장
      </button>
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  components: {
    DevTriggerRestHook: () => import("@/views/dev/trigger/DevTriggerRestHook"),
    DevTriggerPolling: () => import("@/views/dev/trigger/DevTriggerPolling"),
  },

  data() {
    return {
      twoStatus: false,
      formStatus: true,
      codeStatus: false,

      labelStatus: true,
      editStatus: false,

      // 데이터 저장을 위한 부분
      method: null,
      url: null,
      param: [],
      headers: [],
      body: [],
      omits: null,

      emptyParam: 0,
      blankParam: 0,

      requestIndex: 0,

      checkingMenu: "polling",
      saveBtn : false,
      componentChange: "",
      menus: ["DevTriggerRestHook", "DevTriggerPolling"],
    };
  },
  methods: {
    switchView: function () {
      this.formStatus = !this.formStatus;
      this.codeStatus = !this.codeStatus;
    },
    connectionLabelForm: function () {
      this.labelStatus = !this.labelStatus;
      this.editStatus = !this.editStatus;
    },
    deleteInputs: function () {
      console.log("원래는 초기화 시켜야 하는데 그냥 사라지네?");
    },
    changeComponent() {
      console.log(this.checkingMenu);
      if (this.checkingMenu == "hook") {
        console.log("훅");
        this.$store.state.menuType = "hook";
        this.componentChange = this.menus[0];
      } else if (this.checkingMenu == "polling") {
        console.log("poling");
        this.$store.state.menuType = "polling";
        this.componentChange = this.menus[1];
      }
    },
    insertTriggerData() {

      this.saveBtn = true

      document.getElementsByClassName("circleIcon")[0].style.display="revert"
      eventbus.$emit("getInputsData");

      console.log("데이터 저장하는 부분", this.$store.state.menuType);

      // var schemaData = ''

      if (this.$store.state.menuType == "hook") {
        console.log("hook");
      } else {
        // schemaData = JSON.stringify({paramMap : this.$store.state.devStore.paramMap,headerMap : this.$store.state.devStore.headerMap,bodyMap : this.$store.state.devStore.bodyMap})
      }

      console.log(this.requestIndex);
      console.log(this.$store.state.devStore.paramMap[this.requestIndex]);

      // console.log(JSON.parse(this.$store.state.devStore.configureData[0].form)[this.requestIndex].urlParam)

      var paramList = new Map();
      if (this.$store.state.devStore.paramMap[this.requestIndex] != undefined) {
        // for(var i = 0; i < this.$store.state.devStore.paramMap[this.requestIndex].length; i++){
        // console.log(this.$store.state.devStore.paramMap[this.requestIndex][i])
        paramList = this.$store.state.devStore.paramMap[this.requestIndex];
        // }
      }

      console.log(paramList);

      var headerList = new Map();

      if (
        this.$store.state.devStore.headerMap[this.requestIndex] != undefined
      ) {
        //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
        //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
        headerList = this.$store.state.devStore.headerMap[this.requestIndex];
        //     }
      }

      
      console.log(headerList);

      var bodyList = new Map();
      if (this.$store.state.devStore.bodyMap[this.requestIndex] != undefined) {
        //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
        //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
        bodyList = this.$store.state.devStore.bodyMap[this.requestIndex];
        //     }
      }



      console.log(bodyList);
      // console.log(this.$store.state.devStore.optionMap[this.requestIndex])
      //  var optionList = new Map();
      // if(this.$store.state.devStore.optionMap[this.requestIndex] != undefined){

      //     var b = Object.values(Object.fromEntries(this.$store.state.devStore.optionMap[this.requestIndex]))
      //     console.log(Object.values(Object.fromEntries(this.$store.state.devStore.optionMap[this.requestIndex])))

      //     optionList.set(b[0], b[1])
      // }

      // console.log(optionList)

      // var data =  {
      //     url: this.url,
      //     method: this.method,
      //     header: Object.fromEntries(headerList),
      //     urlParam: Object.fromEntries(paramList),
      //     requestBody: Object.fromEntries(bodyList),
      //     // options: Object.fromEntries(optionList),
      //     autoEmptyParam: this.emptyParam,
      //     autoBlankParamDelete: this.blankParam
      // }

      this.$store.state.devStore.configureData[0].connection = "polling";
      this.$store.state.devStore.configureData[0].url = this.url;
      this.$store.state.devStore.configureData[0].method = this.method;

      this.$store.state.devStore.configureData[0].header =
        Object.fromEntries(headerList);
      console.log("왜?")
      this.$store.state.devStore.configureData[0].urlParam =
        Object.fromEntries(paramList);
      this.$store.state.devStore.configureData[0].requestBody =
        Object.fromEntries(bodyList);
      this.$store.state.devStore.configureData[0].autoEmptyParam =
        this.emptyParam;
      this.$store.state.devStore.configureData[0].autoBlankParamDelete =
        this.blankParam;
      this.$store.state.devStore.configureData[0].requestType =
        this.$store.state.devStore.requestType;

      // this.$store.state.devStore.configureData[0] = data

      console.log(
        "직전 데이터 형태는~~",
        JSON.stringify(this.$store.state.devStore.configureData)
      );

      //여기서 저장
      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: this.$store.state.devStore.apiCode,

        checkType: this.$store.state.devStore.apiData.apiName,
        where: "request",

        apiSchema: JSON.stringify(this.$store.state.devStore.configureData),
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          this.saveBtn = false
           document.getElementsByClassName("circleIcon")[0].style.display="none"

          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{
            this.$store.dispatch("apiDetail", {result : res}).then(() => {
              //   this.$router.push({
              //   name: "DevAuthSettings",
              //   params: {
              //   },
              //   });
            });

          })

        })
        .catch(() => alert("오류가 발생했습니다. trigger request"));

      // if(this.method == null && this.url == null){
      //     this.method = this.$store.state.devStore.apiSchema[0].method.replace(/"/gi, '')
      //     this.url = this.$store.state.devStore.apiSchema[0].url.replace(/"/gi, '')
      // }

      //     var params = {

      //     apiCode : this.$store.state.devStore.apiCode,
      //     appCode : this.$store.state.devStore.appCode,

      //     method : this.method,
      //     url : this.url,
      //     type : this.checkingMenu,

      //     paramMap : schemaData,
      //     where : '__request__',
      //     innertype : this.$store.state.menuType
      // }

      // this.$store.dispatch('postSend', { paths : Apiroot.api + Urls.configSchema , params : params})
      // .then((res) => {
      //   console.log("저장 : ", res)

      // }).catch(() => alert('오류가 발생했습니다.'))
    },
  },

  mounted() {},
  created() {
    this.$store.state.devStore.paramMap = [{}, {}, {}, {}];
    this.$store.state.devStore.headerMap = [{}, {}, {}, {}];
    this.$store.state.devStore.bodyMap = [{}, {}, {}, {}];

    // if(this.$route.params.trigName != null){
    // this.$store.state.menuType = 'polling'
    this.componentChange = this.menus[1];
    // }

    eventbus.$on("method", (res, index) => {
      console.log("메소드: ", res, index);

      this.url = res.url;
      this.method = res.method;

      // this.method = res
    });
    // eventbus.$on('url', (res) =>{
    //     console.log(res)
    //     this.url = res
    // })
    eventbus.$on("params", (res) => {
      console.log(res);
      this.param = res;
    });
    eventbus.$on("headers", (res) => {
      console.log("header : ", res);
      this.headers = res;
    });
    eventbus.$on("body", (res) => {
      console.log("body : ", res);
      this.body = res;
    });

    eventbus.$on("omitDatas", (res) => {
      console.log(res);

      this.emptyParam = res[0];
      this.blankParam = res[1];
    });

    // console.log(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam)

    // this.$store.state.devStore.paramMap[0] = JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam

    // if(Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam).length > 0){
    //     var inin = new Array()

    //     for(var i = 0; i < Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam).length; i++){
    //         var data = new Object();
    //         data.keys = Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam)[i]
    //         data.values = Object.values(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].urlParam)[i]
    //         inin.push(data)
    //     }

    //     // this.inputs = inin
    //     this.$store.state.devStore.paramMap[0] = inin

    //     console.log( "param parma : ", this.$store.state.devStore.paramMap[0])
    // }

    // if(Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header).length > 0){
    //     var inin1 = new Array()

    //     for(var j = 0; j < Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header).length; j++){
    //         data = new Object();
    //         data.keys = Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header)[j]
    //         data.values = Object.values(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].header)[j]
    //         inin1.push(data)
    //     }

    //     // this.inputs = inin
    //     this.$store.state.devStore.headerMap[0] = inin1

    //     console.log( "param parma : ", this.$store.state.devStore.headerMap[0])
    // }

    // if(Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].requestBody).length > 0){
    //     var inin2 = new Array()
    //     for(var k = 0; k < Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].requestBody).length; k++){
    //         data = new Object();
    //         data.keys = Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].requestBody)[k]
    //         data.values = Object.values(JSON.parse(this.$store.state.devStore.configureData[0].form)[0].requestBody)[k]
    //         inin2.push(data)
    //     }

    //     // this.inputs = inin
    //     this.$store.state.devStore.bodyMap[0] = inin2

    //     console.log( "param parma : ", this.$store.state.devStore.bodyMap[0])
    // }

    this.emptyParam =
      this.$store.state.devStore.configureData[0].autoEmptyParam.replace(
        /"/gi,
        ""
      );
    this.blankParam =
      this.$store.state.devStore.configureData[0].autoBlankParamDelete.replace(
        /"/gi,
        ""
      );
    this.url = this.$store.state.devStore.configureData[0].url.replace(
      /"/gi,
      ""
    );
    this.method = this.$store.state.devStore.configureData[0].method.replace(
      /"/gi,
      ""
    );

    console.log(
      "형태 변경중:",
      this.$store.state.devStore.configureData[0].url
    );
  },
};
</script>
